import script from "./ScrollContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollContainer.vue?vue&type=script&setup=true&lang=js"

import "./ScrollContainer.vue?vue&type=style&index=0&id=1b63e8d5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b63e8d5"]])

export default __exports__